import { listItemMsg } from '@/shared/components/FormattedListValue';
import { EMPLOYEE_PROFILE_BY_RELATION_FIELD_ID } from '@/shared/relationFieldConstants';

const RenderProperty = props => {
  const { log, intl } = props;

  if (log.fieldId !== null) {
    // The role fields carry the office's own naming, maintained on the employee profile list
    const profile = EMPLOYEE_PROFILE_BY_RELATION_FIELD_ID[String(log.fieldId).toLowerCase()];
    if (profile) return intl.formatMessage(listItemMsg('employeeprofile', profile));

    return intl.formatMessage(listItemMsg('field', log.fieldId));
  }

  return log.label
    ? intl.formatMessage({ id: log.label, defaultMessage: log.label })
    : log.property;
};

export default RenderProperty;
